export default __webpack_public_path__ + "static/media/homeBg.47bbce20.png";